export default __webpack_public_path__ + "static/media/cabourg18.3b8bafdb.jpg";